import React from "react";
import ReactDOM from "react-dom";
import { Link } from "react-router-dom";
import Api from "../../servicios/api";
import Formulario from "./Crear";
import * as XLSX from 'xlsx';
import FormularioEnf1 from "./Enfermedades1";
import FormularioEnf2 from "./Enfermedades2";
import { faFileExcel, faPlus, faStethoscope } from '@fortawesome/free-solid-svg-icons';
import EditarFormulario from "./Editar";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faUpload, faFileUpload, faUserPlus, faSignOutAlt, faSave, faViruses, faDownload } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';

class Listar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      datosCargados: false,
      editar: 'No',
      ver: 'No',
      numero_doc: '',
      query: [],
      pagina: [],
      empresas: [],
      pacienteinfo: [],
      atenciones: [],
      listado: [],
      importando: false,
      creandoAtencion: false,
      tiposAtencion: [],
      usuarios: [],
      pacienteSeleccionado: null,
      mostrarModalEnfermedades: false,
      campoEnfermedad: 'enfermedad'
    };
  }

  cargarEmpresas() {
    fetch(Api + "Empresas")
      .then(respuesta => respuesta.json())
      .then((datosEmpresas) => {
        this.setState({ empresas: datosEmpresas.data });
      })
      .catch(console.log);
  }

  cargarTiposAtencion() {
    const tiposAtencion = [
      { id: 'CONSULTA', nombre: 'Consulta Médica' },
      { id: 'VISITA', nombre: 'Visita Domiciliaria' },
      { id: 'TERAPIA', nombre: 'Terapia' },
      { id: 'CONTROL', nombre: 'Control' }
    ];
    this.setState({ tiposAtencion });
  }

  cargarUsuarios() {
    const usuarios = [
      { id: 'medico1', nombre: 'Dr. Juan Pérez' },
      { id: 'medico2', nombre: 'Dra. María García' },
      { id: 'enfermera1', nombre: 'Enf. Carlos López' }
    ];
    this.setState({ usuarios });
  }

  abrirModalEnfermedades = (campo) => {
    this.setState({
      mostrarModalEnfermedades: true,
      campoEnfermedad: campo
    });
  }

  cerrarModalEnfermedades = () => {
    this.setState({ mostrarModalEnfermedades: false });
  }

  seleccionarEnfermedad = (codigo, descripcion) => {
    const campo = this.state.campoEnfermedad;

    if (campo === 'enfermedad') {
      document.getElementById('enfermedad').value = codigo;
      document.getElementById('descripcion_enf').value = descripcion;
    } else if (campo === 'enfermedad2') {
      document.getElementById('enfermedad2').value = codigo;
      document.getElementById('descripcion_enf2').value = descripcion;
    }

    this.cerrarModalEnfermedades();
  }

  borrarRegistros = (id) => {
    Swal.fire({
      title: 'Estas seguro de eliminar el registro?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Borrar',
      denyButtonText: `No borrar`,
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(Api + "DelPacientes/" + id)
          .then((respuesta) => respuesta.json())
          .then((datosRespuesta) => {
            console.log(datosRespuesta);
            Swal.fire('Borrado!', datosRespuesta.msj, 'success');
            this.Buscar(1);
          })
          .catch(console.log);
      } else if (result.isDenied) {
        Swal.fire('Cancelado', '', 'info');
      }
    });
  };

  abrirCrearAtencion = (paciente) => {
    this.setState({
      pacienteSeleccionado: paciente
    });
  }

  crearAtencion = async (event) => {
    event.preventDefault();

    const formData = new FormData(event.target);
    const datosAtencion = {
      tipo_orden: formData.get('tipo_orden'),
      cantidad: parseInt(formData.get('cantidad')),
      ordenext: formData.get('orden_externa'),
      archivo: formData.get('archivo'),
      fechafin: formData.get('fecha_fin'),
      fechaini: formData.get('fecha_inicio'),
      id_paciente: this.state.pacienteSeleccionado.id_paciente,
      asignado: formData.get('usuario_asignado'),
      observacion: formData.get('observaciones'),
      descripcion: formData.get('descripcion'),
      codigo: formData.get('codigo_atencion'),
      prueba: formData.get('prueba'),
      veces: parseInt(formData.get('veces')),
      cada: parseInt(formData.get('cada_dias')),
      urg: formData.get('urgente'),
      paquete: formData.get('paquete'),
      particular: formData.get('particular'),
      tipo_consulta: formData.get('tipo_consulta'),
      rescov: formData.get('tipo_programa')
    };

    try {
      Swal.fire({
        title: 'Creando atención...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const response = await fetch(Api + "NuevaAtencion", {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'koala2021'
        },
        body: JSON.stringify(datosAtencion)
      });

      const resultado = await response.json();

      if (resultado.estado === "success") {
        Swal.fire({
          icon: 'success',
          title: 'Atención creada',
          text: resultado.msj,
          confirmButtonText: 'Aceptar'
        });
        document.querySelector('#modalCrearAtencion .btn-close').click();
      } else {
        throw new Error(resultado.msj || 'Error al crear la atención');
      }
    } catch (error) {
      console.error('Error creando atención:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.message
      });
    }
  }

  descargarPlantillaOrdenes = () => {
    const datosEjemplo = [
      {
        'NUMERO DOCUMENTO': '123456789',
        'PACIENTE': 'Juan Perez Gomez',
        'ORDEN EXTERNA': 'ORD-001',
        'VISITAS': 3,
        'FECHA INICIO': '2024-01-15',
        'FECHA FIN': '2024-01-20',
        'USUARIO ASIGNADO': 'medico1',
        'CODIGO ATENCION': 'VISITA',
        'DESCRIPCION ATENCION': 'Control médico domiciliario',
        'PRECIO': 150000,
        'FECHA INGRESO': '2026-01-10',
        'OBS': '1 tableta diaria',
        'TIPO_CONSULTA': '1'
      }
    ];

    const ws = XLSX.utils.json_to_sheet(datosEjemplo);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "PlantillaOrdenes");

    const instrucciones = [
      ['INSTRUCCIONES PARA LLENAR LA PLANTILLA DE ÓRDENES'],
      [''],
      ['CAMPO', 'DESCRIPCIÓN', 'VALORES PERMITIDOS'],
      ['NUMERO DOCUMENTO', 'Número de documento del paciente (obligatorio)', 'Debe existir en el sistema'],
      ['PACIENTE', 'Nombre completo del paciente', 'Texto'],
      ['ORDEN EXTERNA', 'Número de orden externa (obligatorio)', 'Texto único'],
      ['VISITAS', 'Número de visitas requeridas', 'Número entero mayor a 0'],
      ['FECHA INICIO', 'Fecha de inicio de las visitas', 'Formato: YYYY-MM-DD'],
      ['FECHA FIN', 'Fecha de finalización de las visitas', 'Formato: YYYY-MM-DD'],
      ['USUARIO ASIGNADO', 'Usuario asignado para la atención', 'medico1, medico2, enfermera1'],
      ['CODIGO ATENCION', 'Tipo de atención', 'CONSULTA, VISITA, TERAPIA, CONTROL'],
      ['DESCRIPCION ATENCION', 'Descripción detallada de la atención', 'Texto'],
      ['PRECIO', 'Precio de la atención', 'Número decimal'],
      ['FECHA INGRESO', 'Fecha de ingreso de la orden', 'Formato: YYYY-MM-DD'],
      ['OBS', 'Observaciones de la orden', '1 tableta diaria, etc.'],
      ['TIPO_CONSULTA', 'Tipo de consulta', '1 si es Ingreso, 0 si es evolucion']
    ];

    const wsInstrucciones = XLSX.utils.aoa_to_sheet(instrucciones);
    XLSX.utils.book_append_sheet(wb, wsInstrucciones, "Instrucciones");
    XLSX.writeFile(wb, "plantilla_ordenes_atencion.xlsx");
  }

  subirOrdenesExcel = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!file.name.match(/\.(xlsx|xls)$/)) {
      Swal.fire({
        icon: 'error',
        title: 'Archivo no válido',
        text: 'Por favor selecciona un archivo Excel (.xlsx o .xls)'
      });
      return;
    }

    Swal.fire({
      title: '¿Subir órdenes de atención?',
      text: `Vas a procesar órdenes desde: ${file.name}`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, subir',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.procesarOrdenesExcel(file);
      } else {
        event.target.value = '';
      }
    });
  }

  procesarOrdenesExcel = (file) => {
    this.setState({ importando: true });

    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);

        if (jsonData.length === 0) {
          Swal.fire({ icon: 'error', title: 'Archivo vacío', text: 'El archivo Excel no contiene datos' });
          this.setState({ importando: false });
          return;
        }

        const datosValidados = this.validarDatosOrdenes(jsonData);

        if (datosValidados.errores.length > 0) {
          this.mostrarErroresValidacion(datosValidados.errores);
          this.setState({ importando: false });
          return;
        }

        this.enviarOrdenesImportacion(datosValidados.datos);
      } catch (error) {
        console.error('Error al procesar archivo:', error);
        Swal.fire({ icon: 'error', title: 'Error', text: 'Error al procesar el archivo Excel' });
        this.setState({ importando: false });
      }
    };

    reader.onerror = () => {
      Swal.fire({ icon: 'error', title: 'Error', text: 'Error al leer el archivo' });
      this.setState({ importando: false });
    };

    reader.readAsArrayBuffer(file);
  }

  validarDatosOrdenes = (datos) => {
    const errores = [];
    const datosValidados = [];

    datos.forEach((fila, index) => {
      const numeroFila = index + 2;

      if (!fila['NUMERO DOCUMENTO']) { errores.push(`Fila ${numeroFila}: El número de documento es obligatorio`); return; }
      if (!fila['PACIENTE']) { errores.push(`Fila ${numeroFila}: El nombre del paciente es obligatorio`); return; }
      if (!fila['ORDEN EXTERNA']) { errores.push(`Fila ${numeroFila}: La orden externa es obligatoria`); return; }
      if (!fila['VISITAS'] || isNaN(fila['VISITAS'])) { errores.push(`Fila ${numeroFila}: El número de visitas es obligatorio y debe ser numérico`); return; }

      datosValidados.push({
        numero_documento: fila['NUMERO DOCUMENTO'].toString(),
        paciente: fila['PACIENTE'],
        orden_externa: fila['ORDEN EXTERNA'],
        visitas: parseInt(fila['VISITAS']),
        fecha_inicio: fila['FECHA INICIO'] || new Date().toISOString().split('T')[0],
        fecha_fin: fila['FECHA FIN'] || new Date().toISOString().split('T')[0],
        usuario_asignado: fila['USUARIO ASIGNADO'] || 'medico1',
        codigo_atencion: fila['CODIGO ATENCION'] || 'CONSULTA',
        descripcion_atencion: fila['DESCRIPCION ATENCION'] || 'Atención médica',
        precio: parseFloat(fila['PRECIO']) || 0,
        fecha_ingreso: fila['FECHA INGRESO'] || new Date().toISOString().split('T')[0],
        obs: fila['OBS'] || '',
        tipo_consulta: fila['TIPO_CONSULTA'] || '0'
      });
    });

    return { datos: datosValidados, errores };
  }

  enviarOrdenesImportacion = async (datos) => {
    try {
      Swal.fire({
        title: 'Procesando órdenes...',
        html: `Procesando ${datos.length} órdenes`,
        allowOutsideClick: false,
        didOpen: () => { Swal.showLoading(); }
      });

      const response = await fetch(Api + "SubirOrdenes", {
        method: "POST",
        headers: { 'Content-Type': 'application/json', 'Authorization': 'koala2021' },
        body: JSON.stringify({ ordenes: datos })
      });

      const resultado = await response.json();

      if (resultado.estado === "success") {
        Swal.fire({
          icon: 'success',
          title: 'Órdenes procesadas',
          html: `<div style="text-align: left;">
            <p><strong>Resumen:</strong></p>
            <p>✅ Archivos creados: ${resultado.archivos_creados}</p>
            <p>✅ Órdenes creadas: ${resultado.ordenes_creadas}</p>
            <p>❌ Errores: ${resultado.errores}</p>
          </div>`,
          width: 500
        });
      } else {
        throw new Error(resultado.msj || 'Error en el procesamiento de órdenes');
      }
    } catch (error) {
      console.error('Error en importación de órdenes:', error);
      Swal.fire({ icon: 'error', title: 'Error en procesamiento', text: error.message });
    } finally {
      this.setState({ importando: false });
      document.getElementById('fileOrdenes').value = '';
    }
  }

  EditRegistros = async (idp) => {
    this.setState({ editar: 'Si' });
    await fetch(Api + "Pacientes/" + idp, {
      method: "GET",
      headers: new Headers({ 'Authorization': 'koala2021' }),
    })
      .then((respuesta) => respuesta.json())
      .then((datosRespuesta) => {
        this.setState({ datosCargados: true, paciente: datosRespuesta });
        document.getElementById('fin').value = datosRespuesta.fecha_reg;
        document.getElementById('fde').value = datosRespuesta.fecha_mod;
        document.getElementById('uat').value = datosRespuesta.ultima_atencion;
        document.getElementById('ual').value = datosRespuesta.ultimo_alquiler;
        document.getElementById('id_paciente').value = datosRespuesta.id_paciente;
        document.getElementById('alta').value = datosRespuesta.alta;
        document.getElementById('documento').value = datosRespuesta.documento;
        document.getElementById('numero_doc').value = datosRespuesta.numero_doc;
        document.getElementById('sexo').value = datosRespuesta.sexo;
        document.getElementById('nombres').value = datosRespuesta.nombres;
        document.getElementById('nombre2').value = datosRespuesta.nombre2;
        document.getElementById('apellidos').value = datosRespuesta.apellidos;
        document.getElementById('apellido2').value = datosRespuesta.apellido2;
        document.getElementById('fecha_nacimiento').value = datosRespuesta.fecha_nacimiento;
        document.getElementById('edad').value = datosRespuesta.edad;
        document.getElementById('civil').value = datosRespuesta.civil;
        document.getElementById('ocupacion').value = datosRespuesta.ocupacion;
        document.getElementById('empresa').value = datosRespuesta.id_empresa;
        document.getElementById('empresa_2').value = datosRespuesta.empresa_secundaria;
        document.getElementById('estado').value = datosRespuesta.estado;
        document.getElementById('regimen').value = datosRespuesta.regimen;
        document.getElementById('tipo_s').value = datosRespuesta.tipo_s;
        document.getElementById('departamento').value = datosRespuesta.departamento;
        document.getElementById('municipio').value = datosRespuesta.municipio;
        document.getElementById('zona').value = datosRespuesta.zona;
        document.getElementById('direccion1').value = datosRespuesta.direccion1;
        document.getElementById('barrio').value = datosRespuesta.barrio;
        document.getElementById('telefono1').value = datosRespuesta.tel_1;
        document.getElementById('celular').value = datosRespuesta.celular;
        document.getElementById('email1').value = datosRespuesta.email1;
        document.getElementById('nombre_familiar').value = datosRespuesta.nombre_acudiente;
        document.getElementById('telefono_familiar').value = datosRespuesta.telefono_acudiente;
        document.getElementById('parentesco').value = datosRespuesta.parentesco;
        document.getElementById('nombre_acudiente').value = datosRespuesta.cedula_acudiente;
        document.getElementById('telefono_acudiente').value = datosRespuesta.dir_pariente;
        document.getElementById('parentesco2').value = datosRespuesta.parentesco2;
        document.getElementById('enfermedad').value = datosRespuesta.enfermedad;
        document.getElementById('descripcion_enf').value = datosRespuesta.descripcion_enf;
        document.getElementById('enfermedad2').value = datosRespuesta.enfermedad2;
        document.getElementById('descripcion_enf2').value = datosRespuesta.descripcion_enf2;
        document.getElementById('deposito').value = datosRespuesta.deposito_alq;
        document.getElementById('subcodigo').value = datosRespuesta.subcodigo;
        document.getElementById('prof_eps').value = datosRespuesta.prof_eps;
        document.getElementById('contrato').value = datosRespuesta.contrato;
        document.getElementById('covid').value = datosRespuesta.covid;
        document.getElementById('observacion_covid').value = datosRespuesta.obs_covid;
        document.getElementById('estado_paciente').value = datosRespuesta.estado_paciente;
        document.getElementById('tipo_copago').value = datosRespuesta.tipo_copago;
        document.getElementById('remision_paciente').value = datosRespuesta.remision;
        this.setState({ numero_doc: datosRespuesta.numero_doc });
      })
      .catch(console.log);

    fetch(Api + "CondicionesPaciente/" + this.state.numero_doc, {
      method: "GET",
      headers: new Headers({ 'Authorization': 'koala2021' }),
    })
      .then((respuestaCond) => respuestaCond.json())
      .then((datosRespuestaCond) => {
        this.setState({ condiciones: datosRespuestaCond });
        document.getElementById('cedula_cond').value = datosRespuestaCond[0].cedula;
        document.getElementById('cond1').value = datosRespuestaCond[0].cond1;
        document.getElementById('cond2').value = datosRespuestaCond[0].cond2;
        document.getElementById('cond3').value = datosRespuestaCond[0].cond3;
        document.getElementById('cond4').value = datosRespuestaCond[0].cond4;
        document.getElementById('cond5').value = datosRespuestaCond[0].cond5;
        document.getElementById('cond6').value = datosRespuestaCond[0].cond6;
        document.getElementById('cond7').value = datosRespuestaCond[0].cond7;
        document.getElementById('cond8').value = datosRespuestaCond[0].cond8;
        document.getElementById('cond9').value = datosRespuestaCond[0].cond9;
        document.getElementById('cond10').value = datosRespuestaCond[0].cond10;
        document.getElementById('cond11').value = datosRespuestaCond[0].cond11;
        document.getElementById('obs1').value = datosRespuestaCond[0].obs1;
        document.getElementById('obs2').value = datosRespuestaCond[0].obs2;
        document.getElementById('obs3').value = datosRespuestaCond[0].obs3;
        document.getElementById('obs4').value = datosRespuestaCond[0].obs4;
        document.getElementById('obs5').value = datosRespuestaCond[0].obs5;
        document.getElementById('obs6').value = datosRespuestaCond[0].obs6;
        document.getElementById('obs7').value = datosRespuestaCond[0].obs7;
        document.getElementById('obs8').value = datosRespuestaCond[0].obs8;
        document.getElementById('obs9').value = datosRespuestaCond[0].obs9;
        document.getElementById('obs10').value = datosRespuestaCond[0].obs10;
        document.getElementById('obs11').value = datosRespuestaCond[0].obs11;
      })
      .catch(console.log);

    fetch(Api + "EncuestasPaciente/" + this.state.numero_doc, {
      method: "GET",
      headers: new Headers({ 'Authorization': 'koala2021' }),
    })
      .then((respuestaEnc) => respuestaEnc.json())
      .then((datosRespuestaEnc) => {
        this.setState({ encuesta: datosRespuestaEnc });
        document.getElementById('cedula_enc').value = datosRespuestaEnc[0].cedula;
        document.getElementById('enc1').value = datosRespuestaEnc[0].enc1;
        document.getElementById('enc2').value = datosRespuestaEnc[0].enc2;
        document.getElementById('enc3').value = datosRespuestaEnc[0].enc3;
        document.getElementById('enc4').value = datosRespuestaEnc[0].enc4;
        document.getElementById('enc5').value = datosRespuestaEnc[0].enc5;
        document.getElementById('enc6').value = datosRespuestaEnc[0].enc6;
        document.getElementById('enc7').value = datosRespuestaEnc[0].enc7;
        document.getElementById('enc8').value = datosRespuestaEnc[0].enc8;
        document.getElementById('enc9').value = datosRespuestaEnc[0].enc9;
        document.getElementById('enc10').value = datosRespuestaEnc[0].enc10;
        document.getElementById('enc11').value = datosRespuestaEnc[0].enc11;
        document.getElementById('enc12').value = datosRespuestaEnc[0].enc12;
        document.getElementById('enc13').value = datosRespuestaEnc[0].enc13;
        document.getElementById('enc14').value = datosRespuestaEnc[0].enc14;
        document.getElementById('enc15').value = datosRespuestaEnc[0].enc15;
        document.getElementById('enc16').value = datosRespuestaEnc[0].enc16;
        document.getElementById('enc17').value = datosRespuestaEnc[0].enc17;
        document.getElementById('enc18').value = datosRespuestaEnc[0].enc18;
        document.getElementById('enc19').value = datosRespuestaEnc[0].enc19;
        document.getElementById('enc20').value = datosRespuestaEnc[0].enc20;
        document.getElementById('enc21').value = datosRespuestaEnc[0].enc21;
        document.getElementById('enc22').value = datosRespuestaEnc[0].enc22;
        document.getElementById('enc23').value = datosRespuestaEnc[0].enc23;
      })
      .catch(console.log);
  }

  componentDidMount() {
    this.Buscar(1);
    this.cargarEmpresas();
    this.cargarTiposAtencion();
    this.cargarUsuarios();
  }

  Buscar(page) {
    let btipo = document.getElementById('buscar').value;
    let bname = document.getElementById('bnombre').value;
    let bemp = document.getElementById('bempresa').value;
    let breg = document.getElementById('bregimen').value;

    if (btipo == '') btipo = 0;
    if (bname == '') bname = 0;
    if (breg == '') breg = 0;

    fetch(Api + "SearchPacientes/" + btipo + "/" + bname + "/" + bemp + "/" + breg + "?page=" + page)
      .then((respuesta) => respuesta.json())
      .then((datosRespuesta) => {
        this.setState({
          datosCargados: true,
          query: datosRespuesta.data,
          pagina: datosRespuesta.total,
          ultimo: datosRespuesta.last_page,
          actual: datosRespuesta.current_page
        });
      })
      .catch(console.log);
  }

  formatearFecha = (fechaString) => {
    if (!fechaString) return '';
    try {
      if (fechaString.includes('-')) {
        const [anio, mes, dia] = fechaString.split('T')[0].split('-');
        return `${dia}/${mes}/${anio}`;
      }
      const fecha = new Date(fechaString);
      if (isNaN(fecha.getTime())) return fechaString;
      const dia = fecha.getDate().toString().padStart(2, '0');
      const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
      const anio = fecha.getFullYear();
      return `${dia}/${mes}/${anio}`;
    } catch (e) {
      console.error('Error al formatear fecha:', e);
      return fechaString;
    }
  }

  descargarPlantilla = () => {
    const datosEjemplo = [
      {
        'TIPO DOCUMENTO': 'CC',
        'NUMERO DOCUMENTO': '123456789',
        'NOMBRES': 'Juan',
        'SEGUNDO NOMBRE': 'Carlos',
        'APELLIDOS': 'Perez',
        'SEGUNDO APELLIDO': 'Gomez',
        'FECHA NACIMIENTO': '1990-01-15',
        'SEXO': 'M',
        'ESTADO CIVIL': 'Soltero',
        'OCUPACION': 'Ingeniero',
        'EMPRESA': 'EPS001',
        'REGIMEN': '1',
        'DEPARTAMENTO': 'Bogotá',
        'MUNICIPIO': 'Bogotá',
        'ZONA': 'Urbana',
        'DIRECCION': 'Calle 123 #45-67',
        'BARRIO': 'Centro',
        'TELEFONO': '6011234567',
        'CELULAR': '3001234567',
        'EMAIL': 'juan@email.com',
        'NOMBRE ACUDIENTE': 'Maria Perez',
        'TELEFONO ACUDIENTE': '3007654321',
        'PARENTESCO': 'Madre',
        'ENFERMEDAD PRINCIPAL': 'A000',
        'DESCRIPCION ENFERMEDAD': 'Diabetes tipo 2',
        'ESTADO PACIENTE': 'Agudo',
        'REMISION': 'Urgencias'
      }
    ];

    const ws = XLSX.utils.json_to_sheet(datosEjemplo);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "PlantillaPacientes");

    const instrucciones = [
      ['INSTRUCCIONES PARA LLENAR LA PLANTILLA'],
      [''],
      ['CAMPO', 'DESCRIPCIÓN', 'VALORES PERMITIDOS'],
      ['TIPO DOCUMENTO', 'Tipo de documento de identidad', 'CC, CE, TI, RC, PA'],
      ['NUMERO DOCUMENTO', 'Número de documento (obligatorio)', 'Solo números, sin puntos ni comas'],
      ['NOMBRES', 'Primer nombre (obligatorio)', 'Texto'],
      ['SEGUNDO NOMBRE', 'Segundo nombre', 'Texto (opcional)'],
      ['APELLIDOS', 'Primer apellido (obligatorio)', 'Texto'],
      ['SEGUNDO APELLIDO', 'Segundo apellido', 'Texto (opcional)'],
      ['FECHA NACIMIENTO', 'Fecha de nacimiento', 'Formato: YYYY-MM-DD'],
      ['SEXO', 'Sexo del paciente', 'M (Masculino), F (Femenino)'],
      ['ESTADO CIVIL', 'Estado civil', 'Soltero, Casado, Divorciado, Viudo, Unión libre'],
      ['OCUPACION', 'Ocupación del paciente', 'Texto'],
      ['EMPRESA', 'Código de la EPS', 'Consultar códigos en el sistema'],
      ['REGIMEN', 'Régimen de salud', '1-13 (Ver lista en sistema)'],
      ['DEPARTAMENTO', 'Departamento de residencia', 'Texto'],
      ['MUNICIPIO', 'Municipio de residencia', 'Texto'],
      ['ZONA', 'Zona de residencia', 'Urbana, Rural'],
      ['DIRECCION', 'Dirección de residencia', 'Texto'],
      ['BARRIO', 'Barrio', 'Texto'],
      ['TELEFONO', 'Teléfono fijo', 'Números'],
      ['CELULAR', 'Número celular', 'Números'],
      ['EMAIL', 'Correo electrónico', 'Email válido'],
      ['NOMBRE ACUDIENTE', 'Nombre del acudiente', 'Texto'],
      ['TELEFONO ACUDIENTE', 'Teléfono del acudiente', 'Números'],
      ['PARENTESCO', 'Parentesco con el acudiente', 'Texto'],
      ['ENFERMEDAD PRINCIPAL', 'Diagnóstico principal', 'Texto'],
      ['DESCRIPCION ENFERMEDAD', 'Descripción de la enfermedad', 'Texto'],
      ['ESTADO PACIENTE', 'Estado del paciente', 'Cronico, Agudo'],
      ['REMISION', 'REMISION del paciente', 'Urgencias, Hospitalizacion']
    ];

    const wsInstrucciones = XLSX.utils.aoa_to_sheet(instrucciones);
    XLSX.utils.book_append_sheet(wb, wsInstrucciones, "Instrucciones");
    XLSX.writeFile(wb, "plantilla_pacientes.xlsx");
  }

  manejarImportacion = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!file.name.match(/\.(xlsx|xls)$/)) {
      Swal.fire({ icon: 'error', title: 'Archivo no válido', text: 'Por favor selecciona un archivo Excel (.xlsx o .xls)' });
      return;
    }

    Swal.fire({
      title: '¿Importar pacientes?',
      text: `Vas a importar datos desde: ${file.name}`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, importar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.procesarArchivoExcel(file);
      } else {
        event.target.value = '';
      }
    });
  }

  procesarArchivoExcel = (file) => {
    this.setState({ importando: true });
    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);

        if (jsonData.length === 0) {
          Swal.fire({ icon: 'error', title: 'Archivo vacío', text: 'El archivo Excel no contiene datos' });
          this.setState({ importando: false });
          return;
        }

        const datosValidados = this.validarDatosExcel(jsonData);

        if (datosValidados.errores.length > 0) {
          this.mostrarErroresValidacion(datosValidados.errores);
          this.setState({ importando: false });
          return;
        }

        this.enviarDatosImportacion(datosValidados.datos);
      } catch (error) {
        console.error('Error al procesar archivo:', error);
        Swal.fire({ icon: 'error', title: 'Error', text: 'Error al procesar el archivo Excel' });
        this.setState({ importando: false });
      }
    };

    reader.onerror = () => {
      Swal.fire({ icon: 'error', title: 'Error', text: 'Error al leer el archivo' });
      this.setState({ importando: false });
    };

    reader.readAsArrayBuffer(file);
  }

  validarDatosExcel = (datos) => {
    const errores = [];
    const datosValidados = [];

    datos.forEach((fila, index) => {
      const numeroFila = index + 2;

      if (!fila['NUMERO DOCUMENTO']) { errores.push(`Fila ${numeroFila}: El número de documento es obligatorio`); return; }
      if (!fila['NOMBRES']) { errores.push(`Fila ${numeroFila}: El nombre es obligatorio`); return; }
      if (!fila['APELLIDOS']) { errores.push(`Fila ${numeroFila}: El apellido es obligatorio`); return; }
      if (!/^\d+$/.test(fila['NUMERO DOCUMENTO'].toString())) { errores.push(`Fila ${numeroFila}: El número de documento debe contener solo números`); return; }

      datosValidados.push({
        documento: fila['TIPO DOCUMENTO'] || 'CC',
        numero_doc: fila['NUMERO DOCUMENTO'].toString(),
        nombres: fila['NOMBRES'],
        nombre2: fila['SEGUNDO NOMBRE'] || '',
        apellidos: fila['APELLIDOS'],
        apellido2: fila['SEGUNDO APELLIDO'] || '',
        fecha_nacimiento: fila['FECHA NACIMIENTO'] || null,
        sexo: fila['SEXO'] || 'M',
        civil: fila['ESTADO CIVIL'] || '',
        ocupacion: fila['OCUPACION'] || '',
        id_empresa: fila['EMPRESA'] || '',
        regimen: fila['REGIMEN'] || '1',
        departamento: fila['DEPARTAMENTO'] || '',
        municipio: fila['MUNICIPIO'] || '',
        zona: fila['ZONA'] || '',
        direccion1: fila['DIRECCION'] || '',
        barrio: fila['BARRIO'] || '',
        tel_1: fila['TELEFONO'] || '',
        celular: fila['CELULAR'] || '',
        email1: fila['EMAIL'] || '',
        nombre_acudiente: fila['NOMBRE ACUDIENTE'] || '',
        telefono_acudiente: fila['TELEFONO ACUDIENTE'] || '',
        parentesco: fila['PARENTESCO'] || '',
        enfermedad: fila['ENFERMEDAD PRINCIPAL'] || '',
        descripcion_enf: fila['DESCRIPCION ENFERMEDAD'] || '',
        estado_paciente: fila['ESTADO PACIENTE'] || 'Agudo',
        estado: 'Activo',
        obs: fila['OBS'] || '',
        tipo_consulta: fila['TIPO_CONSULTA'] || '0'
      });
    });

    return { datos: datosValidados, errores };
  }

  mostrarErroresValidacion = (errores) => {
    const mensajeErrores = errores.slice(0, 10).join('\n');
    const mensajeAdicional = errores.length > 10 ? `\n\n... y ${errores.length - 10} errores más` : '';

    Swal.fire({
      icon: 'error',
      title: 'Errores de validación',
      html: `<div style="text-align: left; max-height: 300px; overflow-y: auto;">
               <pre style="white-space: pre-wrap; font-family: inherit;">${mensajeErrores}${mensajeAdicional}</pre>
             </div>`,
      width: 600
    });
  }

  enviarDatosImportacion = async (datos) => {
    try {
      Swal.fire({
        title: 'Importando pacientes...',
        html: `Procesando ${datos.length} registros`,
        allowOutsideClick: false,
        didOpen: () => { Swal.showLoading(); }
      });

      const response = await fetch(Api + "ImportarPacientes", {
        method: "POST",
        headers: { 'Content-Type': 'application/json', 'Authorization': 'koala2021' },
        body: JSON.stringify({ pacientes: datos })
      });

      const resultado = await response.json();

      if (resultado.estado === "success") {
        Swal.fire({
          icon: 'success',
          title: 'Importación completada',
          html: `<div style="text-align: left;">
            <p><strong>Resumen:</strong></p>
            <p>✅ Registros insertados: ${resultado.insertados}</p>
            <p>⚠️ Registros actualizados: ${resultado.actualizados}</p>
            <p>❌ Registros con error: ${resultado.errores}</p>
            ${resultado.errores > 0 ? `<p><small>Revisa la consola para más detalles de los errores</small></p>` : ''}
          </div>`,
          width: 500
        });
        this.Buscar(1);
      } else {
        throw new Error(resultado.msj || 'Error en la importación');
      }
    } catch (error) {
      console.error('Error en importación:', error);
      Swal.fire({ icon: 'error', title: 'Error en importación', text: error.message });
    } finally {
      this.setState({ importando: false });
      document.getElementById('fileImport').value = '';
    }
  }

  ExportarExcelFrontend = () => {
    const { empresas } = this.state;
    const empresaSeleccionada = document.getElementById('bempresa').value;

    if (empresaSeleccionada === '0' || empresaSeleccionada === '') {
      Swal.fire({ icon: 'error', title: 'Campo requerido', text: 'Debes seleccionar una empresa para exportar', confirmButtonText: 'Entendido' });
      return;
    }

    const empresaNombre = empresas.find(emp => emp.rips === empresaSeleccionada)?.nombre_emp || 'Todos';

    Swal.fire({
      title: 'Exportar a Excel',
      html: `<div class="row g-3">
        <div class="col-md-6">
          <label for="fechaInicio" class="form-label">Fecha inicio</label>
          <input type="date" id="fechaInicio" class="form-control">
        </div>
        <div class="col-md-6">
          <label for="fechaFin" class="form-label">Fecha final</label>
          <input type="date" id="fechaFin" class="form-control">
        </div>
      </div>`,
      showCancelButton: true,
      confirmButtonText: 'Exportar',
      cancelButtonText: 'Cancelar',
      focusConfirm: false,
      preConfirm: () => ({
        fechaInicio: document.getElementById('fechaInicio').value,
        fechaFin: document.getElementById('fechaFin').value
      })
    }).then((result) => {
      if (result.isConfirmed) {
        const { fechaInicio, fechaFin } = result.value;

        if (fechaInicio && fechaFin && new Date(fechaInicio) > new Date(fechaFin)) {
          Swal.fire({ icon: 'error', title: 'Fechas inválidas', text: 'La fecha de inicio no puede ser mayor a la fecha final' });
          return;
        }

        Swal.fire({
          title: 'Preparando archivo...',
          html: `Generando reporte de <b>${empresaNombre}</b><br>${fechaInicio ? `Desde: ${fechaInicio}` : ''} ${fechaFin ? `Hasta: ${fechaFin}` : ''}`,
          allowOutsideClick: false,
          didOpen: () => { Swal.showLoading(); }
        });

        let url = `${Api}ExportarPacientes/${empresaSeleccionada}`;
        if (fechaInicio || fechaFin) {
          url += `?fecha_inicio=${fechaInicio || ''}&fecha_fin=${fechaFin || ''}`;
        }

        fetch(url)
          .then(response => {
            if (!response.ok) throw new Error('Error al obtener los datos');
            return response.json();
          })
          .then(data => {
            const formatearFecha = (fechaString) => {
              if (!fechaString) return '';
              try {
                const parteFecha = fechaString.split(' ')[0];
                const [anio, mes, dia] = parteFecha.split('-');
                return `${dia}/${mes}/${anio}`;
              } catch (e) { return fechaString; }
            };

            const datosFormateados = data.map(item => ({
              'TIPO DOC': item.documento,
              'DOCUMENTO': item.numero_doc,
              'INGRESO': formatearFecha(item.fecha_reg),
              'NOMBRE': item.nombres,
              'SEG NOMBRE': item.nombre2,
              'APELLIDO': item.apellidos,
              'SEG APELLIDO': item.apellido2,
              'EMPRESA': item.id_empresa,
              'TELÉFONO': item.celular,
              'DIRECCIÓN': item.direccion1,
              'DIAGNÓSTICO': item.enfermedad,
              'RÉGIMEN': this.getNombreRegimen(item.regimen),
              'ESTADO': item.estado,
              'SERVICIO': 'Medicina domiciliaria',
              'PROGRAMA': item.estado_paciente
            }));

            const ws = XLSX.utils.json_to_sheet(datosFormateados);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Pacientes");

            let nombreArchivo = `Pacientes_${empresaNombre}`;
            if (fechaInicio) nombreArchivo += `_desde_${fechaInicio}`;
            if (fechaFin) nombreArchivo += `_hasta_${fechaFin}`;
            nombreArchivo += `.xlsx`;

            XLSX.writeFile(wb, nombreArchivo);
            Swal.close();
            Swal.fire({ icon: 'success', title: 'Exportación completada', text: `El archivo se ha descargado correctamente`, confirmButtonText: 'Aceptar' });
          })
          .catch(error => {
            console.error('Error:', error);
            Swal.fire({ icon: 'error', title: 'Error en la exportación', text: error.message, confirmButtonText: 'Entendido' });
          });
      }
    });
  }

  getNombreRegimen = (codigo) => {
    const regimenes = {
      '1': '01 Contributivo cotizante',
      '2': '02 Contributivo beneficiario',
      '3': '03 Contributivo adicional',
      '4': '04 Subsidiado',
      '5': '05 No afiliado',
      '6': '06 Especial o Excepción cotizante',
      '7': '07 Especial o Excepción beneficiario',
      '8': '08 Personas privadas de la libertad',
      '9': '09 Tomador/Amparado ARL',
      '10': '10 Tomador/Amparado SOAT',
      '11': '11 Tomador/Amparado Planes voluntarios',
      '12': '12 Particular',
      '13': '13 Especial o Excepción no cotizante'
    };
    return regimenes[codigo] || codigo;
  }

  render() {
    const {
      datosCargados, paciente, query, pagina, ultimo, actual, empresas,
      editar, importando, tiposAtencion, usuarios, pacienteSeleccionado,
      mostrarModalEnfermedades
    } = this.state;

    if (!datosCargados) {
      var load = 'Cargando datos....';
    } else {
      var load = '';
    }

    return (
      <div className="content">

        {/* ── PORTAL: Modal de Enfermedades ──────────────────────────────────────
            Se monta directamente en document.body para escapar del z-index
            del modal principal de Bootstrap.
        ──────────────────────────────────────────────────────────────────────── */}
        {mostrarModalEnfermedades && ReactDOM.createPortal(
          <>
            {/* Backdrop */}
            <div
              onClick={this.cerrarModalEnfermedades}
              style={{
                position: 'fixed',
                top: 0, left: 0, right: 0, bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                zIndex: 1070,
              }}
            />

            {/* Contenido del modal */}
            <div
              style={{
                position: 'fixed',
                top: '4%',
                left: '50%',
                transform: 'translateX(-50%)',
                width: '92%',
                maxWidth: '960px',
                maxHeight: '88vh',
                overflowY: 'auto',
                zIndex: 1071,
                backgroundColor: '#fff',
                borderRadius: '8px',
                boxShadow: '0 8px 40px rgba(0,0,0,0.35)',
              }}
            >
              {/* Header pegajoso */}
              <div
                className="modal-header"
                style={{
                  position: 'sticky',
                  top: 0,
                  backgroundColor: '#fff',
                  zIndex: 1,
                  borderBottom: '1px solid #dee2e6',
                  padding: '12px 16px',
                }}
              >
                <h5 className="modal-title mb-0">Seleccionar Enfermedad</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={this.cerrarModalEnfermedades}
                  aria-label="Close"
                />
              </div>

              {/* Body */}
              <div className="modal-body">
                <FormularioEnf1
                  onSelect={this.seleccionarEnfermedad}
                  onClose={this.cerrarModalEnfermedades}
                />
              </div>
            </div>
          </>,
          document.body   // ← punto clave: fuera del árbol del modal principal
        )}

        {/* Modal para crear atención */}
        <div className="modal fade" id="modalCrearAtencion" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="modalCrearAtencionLabel" aria-hidden="true">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="modalCrearAtencionLabel">
                  <FontAwesomeIcon icon={faStethoscope} />&nbsp;
                  Crear Atención para {pacienteSeleccionado ? `${pacienteSeleccionado.nombres} ${pacienteSeleccionado.apellidos}` : ''}
                </h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <form onSubmit={this.crearAtencion}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Tipo de Orden</label>
                        <select className="form-select" name="tipo_orden" required>
                          <option value="">Seleccionar...</option>
                          <option value="1">Orden Simple</option>
                          <option value="2">Orden Múltiple</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Cantidad de Visitas</label>
                        <input type="number" className="form-control" name="cantidad" min="1" required defaultValue="1" />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Orden Externa</label>
                        <input type="text" className="form-control" name="orden_externa" required />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Archivo</label>
                        <input type="text" className="form-control" name="archivo" required />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Fecha Inicio</label>
                        <input type="datetime-local" className="form-control" name="fecha_inicio" required />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Fecha Fin</label>
                        <input type="datetime-local" className="form-control" name="fecha_fin" required />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Usuario Asignado</label>
                        <select className="form-select" name="usuario_asignado" required>
                          <option value="">Seleccionar...</option>
                          {usuarios.map(usuario => (
                            <option key={usuario.id} value={usuario.id}>{usuario.nombre}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Código Atención</label>
                        <select className="form-select" name="codigo_atencion" required>
                          <option value="">Seleccionar...</option>
                          {tiposAtencion.map(tipo => (
                            <option key={tipo.id} value={tipo.id}>{tipo.nombre}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Descripción</label>
                    <textarea className="form-control" name="descripcion" rows="3" required></textarea>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label">Veces</label>
                        <input type="number" className="form-control" name="veces" min="1" defaultValue="1" />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label">Cada (días)</label>
                        <input type="number" className="form-control" name="cada_dias" min="1" defaultValue="1" />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label">Urgente</label>
                        <select className="form-select" name="urgente">
                          <option value="No">No</option>
                          <option value="Si">Sí</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Tipo de Consulta</label>
                        <input type="text" className="form-control" name="tipo_consulta" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Tipo de Programa</label>
                        <input type="text" className="form-control" name="tipo_programa" />
                      </div>
                    </div>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Observaciones</label>
                    <textarea className="form-control" name="observaciones" rows="2"></textarea>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                    <button type="submit" className="btn btn-primary">Crear Atención</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Modal principal de pacientes (Crear / Editar) */}
        <div className="modal fade" id="nuevoPacienteSub" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="nuevoPacienteSubLabel" aria-hidden="true">
          {editar === "No" ? (
            <Formulario onOpenEnfermedades={this.abrirModalEnfermedades} />
          ) : (
            <EditarFormulario
              usuario={paciente}
              func={this.Buscar}
              onOpenEnfermedades={this.abrirModalEnfermedades}
            />
          )}
        </div>

        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <div className="col-xl-12">
                <form style={{ float: 'right' }} className="row g-3">
                  <div className="col-md-12">
                    <button className='btn btn-info btn-sm' onClick={this.descargarPlantilla} disabled={importando}>
                      <FontAwesomeIcon icon={faDownload} />&nbsp;&nbsp;Descargar Plantilla Pacientes
                    </button>&nbsp;&nbsp;

                    <button className='btn btn-info btn-sm' onClick={this.descargarPlantillaOrdenes} disabled={importando}>
                      <FontAwesomeIcon icon={faDownload} />&nbsp;&nbsp;Descargar Plantilla Órdenes
                    </button>&nbsp;&nbsp;

                    <label htmlFor="fileImport" className='btn btn-warning btn-sm' style={{ cursor: 'pointer', marginBottom: 0 }} disabled={importando}>
                      <FontAwesomeIcon icon={faUpload} />&nbsp;&nbsp;
                      {importando ? 'Importando...' : 'Importar Pacientes'}
                    </label>
                    <input type="file" id="fileImport" accept=".xlsx,.xls" style={{ display: 'none' }} onChange={this.manejarImportacion} disabled={importando} />&nbsp;&nbsp;

                    <label htmlFor="fileOrdenes" className='btn btn-success btn-sm' style={{ cursor: 'pointer', marginBottom: 0 }} disabled={importando}>
                      <FontAwesomeIcon icon={faFileUpload} />&nbsp;&nbsp;
                      {importando ? 'Procesando...' : 'Subir Órdenes'}
                    </label>
                    <input type="file" id="fileOrdenes" accept=".xlsx,.xls" style={{ display: 'none' }} onChange={this.subirOrdenesExcel} disabled={importando} />&nbsp;&nbsp;

                    <button className='btn btn-primary btn-sm' id='btnNuevoPacienteSub' type='button' data-bs-toggle='modal' data-bs-target='#nuevoPacienteSub' onClick={() => this.setState({ editar: 'No' })}>
                      <FontAwesomeIcon icon={faUserPlus} />&nbsp;&nbsp;Nuevo Paciente
                    </button>
                  </div>
                </form>
              </div>
            </div>

            <div className="card-body">
              <h4>Lista de Pacientes</h4>
              <div className="row">
                <div className="col-xl-2">
                  <input type="text" id="buscar" name="buscar" placeholder="Cedula del Paciente" className="form-control form-control-sm" />
                </div>
                <div className="col-xl-2">
                  <input type="text" id="bnombre" name="bnombre" placeholder="Nombre del Paciente" className="form-control form-control-sm" />
                </div>
                <div className="col-xl-2">
                  <select className="form-select form-select-sm" name="bempresa" id="bempresa">
                    <option value="0">Todas las EPS</option>
                    {empresas.map(itemEmpresa => (
                      <option key={itemEmpresa.id_empresa} value={itemEmpresa.rips}>{itemEmpresa.nombre_emp}</option>
                    ))}
                  </select>
                </div>
                <div className="col-xl-2">
                  <select className="form-select form-select-sm" name="bregimen" id="bregimen">
                    <option value="0">Regimen</option>
                    <option value="1">01 Contributivo cotizante</option>
                    <option value="2">02 Contributivo beneficiario</option>
                    <option value="3">03 Contributivo adicional</option>
                    <option value="4">04 Subsidiado</option>
                    <option value="5">05 No afiliado</option>
                    <option value="6">06 Especial o Excepción cotizante</option>
                    <option value="7">07 Especial o Excepción beneficiario</option>
                    <option value="8">08 Personas privadas de la libertad a cargo del Fondo Nacional de Salud</option>
                    <option value="9">09 Tomador / Amparado ARL</option>
                    <option value="10">10 Tomador / Amparado SOAT</option>
                    <option value="11">11 Tomador / Amparado Planes voluntarios de salud</option>
                    <option value="12">12 Particular</option>
                    <option value="13">13 Especial o Excepción no cotizante Ley 352 de 1997</option>
                  </select>
                </div>
                <div className="col-xl-2">
                  <input type="button" id="bt" name="bt" className="btn btn-primary btn-sm" value="Filtrar" onClick={() => this.Buscar(1)} />
                  &nbsp;
                  <button className='btn btn-success btn-sm' onClick={this.ExportarExcelFrontend} disabled={!this.state.empresas.length}>
                    <FontAwesomeIcon icon={faFileExcel} />&nbsp;&nbsp;Exportar Excel
                  </button>
                </div>
              </div>

              <br />

              <div className="row">
                <table className="table table-hover table-condensed table-sm">
                  <thead className="thead-inverse">
                    <tr>
                      <th>TIPO DE IDENTIFICACION</th>
                      <th>IDENTIFICACIÓN</th>
                      <th>NOMBRE PACIENTE</th>
                      <th>EMPRESA</th>
                      <th>TELÉFONO</th>
                      <th>DIRECCION</th>
                      <th>DIAGNOSTICO</th>
                      <th>REGIMEN</th>
                      <th>REMISION</th>
                      <th>TIPO PAC</th>
                      <th>ESTADO</th>
                      <th>ACCIONES</th>
                    </tr>
                  </thead>
                  <tbody>
                    {load}
                    {query.map((empleado) => (
                      <tr key={empleado.id_paciente}>
                        <td>{empleado.documento}</td>
                        <td>{empleado.numero_doc}</td>
                        <td>{empleado.nombres} {empleado.apellidos}</td>
                        <td>{empleado.id_empresa}</td>
                        <td>{empleado.celular}</td>
                        <td>{empleado.direccion1}</td>
                        <td>{empleado.enfermedad}</td>
                        <td>{this.getNombreRegimen(empleado.regimen)}</td>
                        <td>{empleado.remision}</td>
                        <td>{empleado.estado_paciente}</td>
                        <td>
                          {empleado.estado === "No Activo" ? (
                            <span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-danger">{empleado.estado}</span>
                          ) : (
                            <span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-success">{empleado.estado}</span>
                          )}
                        </td>
                        <td>
                          <div className="btn-group" role="group">
                            <Link className="btn btn-primary btn-sm" to={"/InfoPacientes/" + empleado.id_paciente}>
                              <i className="fas fa-info-circle"></i>
                            </Link>&nbsp;&nbsp;

                            <button
                              type="button"
                              className="btn btn-info btn-sm"
                              data-bs-toggle='modal'
                              data-bs-target='#modalCrearAtencion'
                              onClick={() => this.abrirCrearAtencion(empleado)}
                            >
                              <FontAwesomeIcon icon={faStethoscope} />
                            </button>&nbsp;&nbsp;

                            <button
                              type="button"
                              className="btn btn-warning btn-sm"
                              data-bs-toggle='modal'
                              data-bs-target='#nuevoPacienteSub'
                              onClick={() => this.EditRegistros(empleado.id_paciente)}
                            >
                              <i className="fas fa-edit"></i>
                            </button>&nbsp;&nbsp;

                            <button
                              type="button"
                              className="btn btn-danger btn-sm"
                              onClick={() => this.borrarRegistros(empleado.id_paciente)}
                            >
                              <i className="far fa-trash-alt"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <nav aria-label="Page navigation example">
                <ul className="pagination">
                  <li className="page-item"><a className="page-link" href="#" onClick={() => this.Buscar(1)}>Atras</a></li>
                  {(() => {
                    let p = [];
                    const ult = ultimo >= 20 ? 20 : ultimo;
                    for (let i = 1; i <= ult; i++) {
                      p.push(
                        <li className="page-item" key={i}>
                          <a className="page-link" href="#" onClick={() => this.Buscar(i)}>{i}</a>
                        </li>
                      );
                    }
                    return p;
                  })()}
                  <li className="page-item"><a className="page-link" href="#" onClick={() => this.Buscar(ultimo)}>Siguiente</a></li>
                </ul>
                Pagina {actual} de {ultimo} Registros {pagina}
              </nav>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Listar;